import { UserTypes } from '$types/UserTypes';

export default function getUserType(): UserTypes {
  if (localStorage.getItem('ServerInternalResponse')) return UserTypes.INTERNAL;
  if (localStorage.getItem('ServerEmployerResponse')) return UserTypes.EMPLOYER;
  if (localStorage.getItem('ServerCandidateResponse'))
    return UserTypes.CANDIDATE;
  return UserTypes.GUEST;
}
